import { CircularProgress } from "@suraasa/placebo-ui"
import { ToolType } from "api/resources/aiTools/types"
import { getToolName } from "features/AItools/helper"

import Heading from "../../Heading"
import AssignmentOutput from "../GenerationOutput/AssignmentOutput"
import ContentActions from "../GenerationOutput/Export/ContentActions"
import ProForm from "./ProForm"
import { useAssignment } from "./useAssignment"

const AssignmentGenerator = ({
  toggleHistorySideBar,
}: {
  toggleHistorySideBar: (state: boolean) => void
}) => {
  const {
    currentResponseId,
    setCurrentResponseId,
    promptDataId,
    pageLoading,
    onBack,
    ...assignmentContext
  } = useAssignment()

  if (promptDataId && pageLoading) {
    return (
      <div className="grid place-items-center p-4">
        <CircularProgress />
      </div>
    )
  }
  if (currentResponseId) {
    return (
      <>
        <ContentActions
          onBack={onBack}
          currentResponseId={currentResponseId}
          toolType={ToolType.assignment}
          title={assignmentContext.overviewData?.title}
          toggleHistorySideBar={toggleHistorySideBar}
          hideExportOutputButton={
            assignmentContext.isLoading ||
            assignmentContext.isError ||
            currentResponseId === undefined
          }
        />

        <AssignmentOutput
          {...assignmentContext}
          currentResponseId={currentResponseId}
          setCurrentResponseId={setCurrentResponseId}
          onBack={onBack}
        />
      </>
    )
  }

  return (
    <>
      <Heading
        title={`${getToolName(ToolType.assignment)} Generator`}
        subtitle="A tool for creating assignments based on your preferences and specifications."
        toggleHistorySideBar={toggleHistorySideBar}
      />
      {/* <TogglePro
        isPro={enableProMode}
        onChange={state => setEnableProMode(state)}
        className="mb-2"
      /> */}
      <ProForm {...assignmentContext} />
      {/* {enableProMode ? (
        <ProForm {...assignmentContext} />
      ) : (
        <BasicForm {...assignmentContext} />
      )} */}
    </>
  )
}

export default AssignmentGenerator
